import { Capacitor } from "@capacitor/core";
import { PushNotifications } from "@capacitor/push-notifications";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase";

let listenersAttached = false;

function isNativeMobile() {
  const platform = Capacitor.getPlatform();
  return platform === "android" || platform === "ios";
}

export async function registerPushForUser(userId) {
  if (!userId || !isNativeMobile()) return null;

  const permStatus = await PushNotifications.checkPermissions();
  let receive = permStatus.receive;

  if (receive !== "granted") {
    const req = await PushNotifications.requestPermissions();
    receive = req.receive;
  }

  if (receive !== "granted") {
    await setDoc(
      doc(db, "users", userId),
      {
        notificationsEnabled: false,
        pushPermission: receive,
        pushPlatform: Capacitor.getPlatform(),
        pushPermissionUpdatedAt: serverTimestamp(),
      },
      { merge: true }
    );
    return null;
  }

  const token = await new Promise((resolve, reject) => {
    const onReg = PushNotifications.addListener("registration", (t) => {
      resolve(t.value);
      onReg.remove();
      onErr.remove();
    });
    const onErr = PushNotifications.addListener("registrationError", (err) => {
      reject(err);
      onReg.remove();
      onErr.remove();
    });
    PushNotifications.register();
  });

  await setDoc(
    doc(db, "users", userId),
    {
      fcmToken: token,
      notificationsEnabled: true,
      pushPermission: "granted",
      pushPlatform: Capacitor.getPlatform(),
      fcmTokenUpdatedAt: serverTimestamp(),
    },
    { merge: true }
  );

  if (!listenersAttached) {
    listenersAttached = true;
    PushNotifications.addListener("pushNotificationReceived", (notification) => {
      console.log("Push received:", notification);
    });

    PushNotifications.addListener("pushNotificationActionPerformed", (action) => {
      console.log("Push action:", action);
    });
  }

  return token;
}
